export const breakpoints = {
  xs: 375, // Mobile
  s: 768, // Tablet
  m: 1008, // Desktop and up
  l: 1248,
  xl: 1440,
  xxl: 1680,
  xxl2: 1980,
} as const;
